<h1 class="fw-bolder fs-4x text-gray-700 mb-10">{{"errors.500.title" | translate}}</h1>

<div class="fw-bold fs-3 text-gray-400 mb-15" [innerHTML]="translate.instant('errors.500.subtitle')">
  Qualcosa è andato storto! <br />
  Riprova più tardi.
</div>
